// Shared motion system — single source of truth for easing, duration, stagger.
// Brand: calm, soft, deliberate, premium. No bounce, no overshoot.

export const EASE = [0.22, 1, 0.36, 1];

export const SOFT_SPRING = { type: "spring", stiffness: 80, damping: 20 };

export const fadeUp = {
  hidden: { opacity: 0, y: 24, filter: "blur(4px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.4, ease: EASE },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.4, ease: EASE } },
};

export const slideInRight = {
  hidden: { opacity: 0, x: 40 },
  show: { opacity: 1, x: 0, transition: { duration: 0.4, ease: EASE } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.6 },
  show: { opacity: 1, scale: 1, transition: SOFT_SPRING },
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

export const staggerSlow = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

// Reduced-motion variants: instant opacity only (no transform / blur).
export const fadeUpReduced = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.2 } },
};

export const scaleInReduced = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.2 } },
};

export const slideInRightReduced = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.2 } },
};

// Reveal config: plays once when a section first enters view, then stays shown
// (does not re-hide when scrolled out of view).
export const VIEWPORT_REVEAL = { once: true, amount: 0.10 };
